import { createAction } from 'redux-actions';

const namespace = 'crdf.journeys.activeJourneyModal';

export const OPEN_UNFINISHED_MODAL = `${namespace}.open`;
export const CLOSE_UNFINISHED_MODAL = `${namespace}.close`;

export const openUnfinishedModal = createAction(OPEN_UNFINISHED_MODAL);
export const closeUnfinishedModal = createAction(CLOSE_UNFINISHED_MODAL);
